import Tool from "./Tool";
import MouseEventArgs from "./MouseEventArgs";
import Editor from "./Editor";
import NodeLayer from "./NodeLayer";

export default class ToolChain extends Tool {
  private _chain: Array<Tool>;

  public constructor(editor: Editor, name: string, chain: Array<Tool>) {
    super(editor, name);
    this._chain = chain;
  }

  public handleMouseDown(arg: MouseEventArgs): boolean {
    for (var i = 0; i < this._chain.length; i++) {
      if (this._chain[i].handleMouseDown(arg)) {
        return true;
      }
    }
    return false;
  }

  public handleMouseMove(arg: MouseEventArgs): boolean {
    for (var i = 0; i < this._chain.length; i++) {
      if (this._chain[i].handleMouseMove(arg)) {
        return true;
      }
    }

    return false;
  }

  public handleMouseUp(arg: MouseEventArgs): boolean {
    for (var i = 0; i < this._chain.length; i++) {
      if (this._chain[i].handleMouseUp(arg)) {
        return true;
      }
    }

    return false;
  }

  public handleMouseWheel(arg: MouseEventArgs): boolean {
    for (var i = 0; i < this._chain.length; i++) {
      if (this._chain[i].handleMouseWheel(arg)) {
        return true;
      }
    }

    return false;
  }

  public handleDelete() {
    for (var i = 0; i < this._chain.length; i++) {
      if (this._chain[i].handleDelete()) {
        return true;
      }
    }
    return false;
  }

  public draw(context: CanvasRenderingContext2D) {
    for (var i = 0; i < this._chain.length; i++) {
      this._chain[i].draw(context);
    }
  }

  public finalize() {
    for (var i = 0; i < this._chain.length; i++) {
      this._chain[i].finalize();
    }
  }

  public initialize() {
    for (var i = 0; i < this._chain.length; i++) {
      this._chain[i].initialize();
    }
  }
}
